import { render, staticRenderFns } from "./SendError4Window.vue?vue&type=template&id=5aeba37b&scoped=true"
import script from "./SendError4Window.vue?vue&type=script&lang=js"
export * from "./SendError4Window.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeba37b",
  null
  
)

export default component.exports